import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const EqualsIcon = ({ label = 'Equals', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path style="fill:#ff9015" d="M40.5 167.1h219v64.55h-219z"/><path d="M259.5 167.1v64.6h-219v-64.6h219m0-10h-219a10 10 0 0 0-10 10v64.6a10 10 0 0 0 10 10h219a10 10 0 0 0 10-10v-64.6a10 10 0 0 0-10-10z" style="fill:#1d1d1b"/><path d="M53.2 215.6a3.5 3.5 0 0 1-3.5-3.5v-4.3a3.4 3.4 0 0 1 3.5-3.5 3.5 3.5 0 0 1 3.5 3.5v4.3a3.5 3.5 0 0 1-3.5 3.5zm0-16.2a3.4 3.4 0 0 1-3.5-3.5v-16.1a3.4 3.4 0 0 1 3.5-3.5 3.5 3.5 0 0 1 3.5 3.5v16.1a3.5 3.5 0 0 1-3.5 3.5z" style="fill:#1d1d1b"/><path style="fill:#ff9015" d="M40 67.9h219v64.55H40z"/><path d="M259.1 67.9v64.6H40V67.9h219.1m0-10H40a10 10 0 0 0-10 10v64.6a10 10 0 0 0 10 10h219.1a10 10 0 0 0 10-10V67.9a10 10 0 0 0-10-10z" style="fill:#1d1d1b"/><path d="M52.7 116.4a3.5 3.5 0 0 1-3.5-3.5v-4.3a3.5 3.5 0 0 1 7 0v4.3a3.5 3.5 0 0 1-3.5 3.5zm0-16.2a3.5 3.5 0 0 1-3.5-3.5V80.6a3.5 3.5 0 0 1 7 0v16.1a3.5 3.5 0 0 1-3.5 3.5z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

EqualsIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { EqualsIcon }
